import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";

import PrimaryButton from "@components/buttons/PrimaryButton";
import InternalLink from "@components/typography/InternalLink";
import useMyClient from "@hooks/useMyClient";
import { journeyRoute } from "@utils/routeUtils";

type Props = {
  color?: ComponentProps<typeof PrimaryButton>["color"];
  expand?: boolean;
  hideIcon?: boolean;
  isRouterLink?: boolean;
  journeyId: string;
  messageKey?: string;
  onClick?: () => void;
  size?: "large" | "small";
};

const ScheduleConsultButton = ({
  color = "primary",
  expand = false,
  hideIcon = false,
  isRouterLink = false,
  journeyId,
  messageKey,
  onClick,
  size
}: Props) => {
  const myClient = useMyClient();

  return (
    <>
      {isRouterLink ? (
        <InternalLink to={journeyRoute({ journeyId, linkAfterJourney: "/schedule-consult", myClient })}>
          <FormattedMessage id={messageKey ?? "pages.client.consults.scheduleConsult"} />
        </InternalLink>
      ) : (
        <PrimaryButton
          color={color}
          data-test="schedule-consult"
          expand={expand ? "block" : undefined}
          icon={hideIcon ? undefined : "calendarCheck"}
          onClick={onClick}
          routerLink={journeyRoute({ journeyId, linkAfterJourney: "/schedule-consult", myClient })}
          size={size}
          textKey={messageKey ?? "pages.client.consults.scheduleConsult"}
        />
      )}
    </>
  );
};

export default ScheduleConsultButton;
